import { DEFAULT_TRIANGLE_PROPS } from '../../../../../Shape/config/Shapes';

const isRight = shape => (shape.get('isRight') ?
    shape.get('isRight') :
    DEFAULT_TRIANGLE_PROPS.isRight);

export default isRight;
